"use client";

import { useEffect } from "react";

import {
  captureInboundSourceCode,
  clearInboundSourceCode,
} from "@/lib/cta-analytics";
import {
  CONSENT_CHANGED_EVENT,
  hasConsent,
  type ConsentPreferences,
} from "@/lib/legal/consent";

export default function InboundSourceCapture() {
  useEffect(() => {
    const syncSource = (analyticsAllowed: boolean) => {
      if (analyticsAllowed) {
        captureInboundSourceCode();
      } else {
        clearInboundSourceCode();
      }
    };

    syncSource(hasConsent("analytics"));

    const handleConsentChange = (event: Event) => {
      const preferences = (event as CustomEvent<ConsentPreferences>).detail;
      syncSource(preferences?.analytics === true);
    };

    window.addEventListener(CONSENT_CHANGED_EVENT, handleConsentChange);
    return () =>
      window.removeEventListener(CONSENT_CHANGED_EVENT, handleConsentChange);
  }, []);

  return null;
}
